<div
    class="font-inter w-full h-full bg-[linear-gradient(359deg,_var(--p-content-background)_83.33%,_var(--p-content-hover-background)_99.08%)]">
    <div class="w-full h-full p-4">
        <div class="flex flex-col items-center justify-between h-full">
            <div class="flex flex-col items-center justify-start gap-4 w-full">
                @if (panelOpen) {
                    @if (currentUser.userId) {
                        <div class="flex flex-col items-start justify-start w-full gap-2">
                            <div class="w-full flex flex-row justify-between items-start">
                                <fm-avatar
                                    class="cursor-pointer"
                                    [sizePx]="48"
                                    [avatarLocation]="currentUser.photo"
                                    (click)="onClickAvatar()" />
                                <p-button
                                    [buttonProps]="{ autofocus: false }"
                                    (click)="onClickProfileButton()"
                                    pTooltip="My Profile"
                                    routerLink="/profile"
                                    class="flex"
                                    size="small"
                                    severity="secondary"
                                    [outlined]="true"
                                    styleClass="aspect-square"
                                    icon="pi pi-id-card">
                                    <span class="sr-only">See my profile</span>
                                </p-button>
                            </div>
                            <div class="flex flex-col items-start justify-start w-full gap-1">
                                <div
                                    class="w-full text-left text-base leading-normal font-semibold text-color"
                                    ><fm-home-welcome-message />,<br />{{
                                        currentUser.firstName
                                    }}!</div
                                >
                                <div class="text-12 leading-[normal] text-muted-color font-light">
                                    @if (
                                        meetingsService.completedSessionCountSubject | async;
                                        as count
                                    ) {
                                        <div>
                                            {{ count | number }}
                                            {{ count === 1 ? 'session' : 'sessions' }}
                                        </div>
                                    }
                                </div>
                                @if (
                                    currentUser.ambassadorSessionsAttended > 0 ||
                                    (currentUser.isHost &&
                                        featureCheckService.groupMeetingsEnabledSig())
                                ) {
                                    <div class="flex flex-row items-center gap-2">
                                        @if (currentUser.ambassadorSessionsAttended > 0) {
                                            <fm-ambassador-sessions-badge
                                                [ambassadorSessionsAttended]="
                                                    currentUser.ambassadorSessionsAttended
                                                "
                                                size="small" />
                                        }
                                        <fm-host-badge
                                            size="small"
                                            [isHost]="!!currentUser.isHost"
                                            [groupSessionsHosted]="
                                                currentUser.groupSessionsHosted ?? 0
                                            "
                                            [viewingSelf]="true" />
                                    </div>
                                }
                                <div class="text-12 leading-[normal] text-muted-color font-light">
                                    {{ planNameString }}
                                </div>
                                @if (trialDaysRemaining && trialDaysRemaining > 0) {
                                    <p-message
                                        severity="warn"
                                        variant="text"
                                        styleClass="w-full !rounded-lg">
                                        <ng-template #container>
                                            <div
                                                class="w-full flex items-center justify-center font-semibold text-12">
                                                {{ trialDaysRemaining }} days left in trial
                                            </div>
                                        </ng-template>
                                    </p-message>
                                }
                            </div>
                            @if (showUpgradeButton) {
                                <p-button
                                    [buttonProps]="{ autofocus: false }"
                                    routerLink="/upgrade"
                                    [state]="{ source: 'dynamicPanelHome' }"
                                    (click)="onClickUpgrade()"
                                    severity="primary"
                                    label="Upgrade to Plus"
                                    size="small" />
                            }
                        </div>
                    }
                    <div class="flex flex-col gap-2 w-full">
                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            (click)="onClickYourSchedule()"
                            severity="secondary"
                            [outlined]="true"
                            class="w-full"
                            styleClass="w-full">
                            <div class="w-full flex items-center justify-between">
                                <div
                                    ><i class="pi pi-calendar" style="font-size: 14px"></i
                                    ><span class="ml-1 font-semibold">My Schedule</span>
                                </div>
                                <div class="flex items-center justify-center"
                                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                                ></div>
                            </div>
                        </p-button>

                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            (click)="onClickFavoritesSchedule()"
                            severity="secondary"
                            [outlined]="true"
                            class="w-full"
                            styleClass="w-full">
                            <div class="w-full flex items-center justify-between">
                                <div
                                    ><i class="pi pi-star-fill" style="font-size: 14px"></i
                                    ><span class="ml-1 font-semibold">Favorites Schedule</span>
                                </div>
                                <div class="flex items-center justify-center"
                                    ><i class="pi pi-chevron-right" style="font-size: 14px"></i
                                ></div>
                            </div>
                        </p-button>

                        @if (featureCheckService.groupMeetingsEnabledSig()) {
                            <p-button
                                [buttonProps]="{ autofocus: false }"
                                (click)="onClickGroupSessions()"
                                severity="secondary"
                                [outlined]="true"
                                class="w-full"
                                styleClass="w-full">
                                <div class="w-full flex items-center justify-between">
                                    <div class="flex items-center gap-1.5">
                                        <fm-icon name="flower" size="14px" />
                                        <span class="font-semibold">Group Sessions</span>
                                    </div>
                                    <div class="flex items-center justify-end gap-2">
                                        <p-tag
                                            styleClass="!text-10 !leading-[normal] !rounded-md !font-medium !px-1.5 !py-0.5"
                                            severity="info"
                                            value="Labs" />
                                        <i class="pi pi-chevron-right" style="font-size: 14px"></i>
                                    </div>
                                </div>
                            </p-button>
                        }
                        @if (isTaskManagerEnabled()) {
                            <p-button
                                [buttonProps]="{ autofocus: false }"
                                (click)="onClickTaskManager()"
                                severity="secondary"
                                [outlined]="true"
                                class="w-full"
                                styleClass="w-full">
                                <div class="w-full flex items-center justify-between">
                                    <div class="flex items-center gap-1.5">
                                        <i class="pi pi-check-square" style="font-size: 14px"></i>
                                        <span class="font-semibold">Task Manager</span>
                                    </div>
                                    <div class="flex items-center justify-end gap-2">
                                        <p-tag
                                            styleClass="!text-10 !leading-[normal] !rounded-md !font-medium !px-1.5 !py-0.5"
                                            severity="info"
                                            value="Labs" />
                                        <i class="pi pi-chevron-right" style="font-size: 14px"></i>
                                    </div>
                                </div>
                            </p-button>
                        }
                    </div>
                } @else {
                    <div class="flex flex-col gap-2">
                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            (click)="onClickYourSchedule()"
                            size="small"
                            severity="secondary"
                            [outlined]="true"
                            pTooltip="My Schedule"
                            styleClass="aspect-square"
                            icon="pi pi-calendar">
                            <span class="sr-only">My Schedule</span>
                        </p-button>

                        <p-button
                            [buttonProps]="{ autofocus: false }"
                            (click)="onClickFavoritesSchedule()"
                            size="small"
                            severity="secondary"
                            [outlined]="true"
                            pTooltip="Favorites Schedule"
                            styleClass="aspect-square"
                            icon="pi pi-star-fill">
                            <span class="sr-only">Favorites Schedule</span>
                        </p-button>

                        @if (featureCheckService.groupMeetingsEnabledSig()) {
                            <p-button
                                [buttonProps]="{ autofocus: false }"
                                (click)="onClickGroupSessions()"
                                size="small"
                                styleClass="aspect-square"
                                severity="secondary"
                                [outlined]="true"
                                pTooltip="Group Sessions">
                                <ng-template #icon>
                                    <fm-icon name="flower" size="14px" />
                                </ng-template>
                                <span class="sr-only">Group Sessions</span>
                            </p-button>
                        }

                        @if (isTaskManagerEnabled()) {
                            <p-button
                                [buttonProps]="{ autofocus: false }"
                                (click)="onClickTaskManager()"
                                size="small"
                                styleClass="aspect-square"
                                severity="secondary"
                                [outlined]="true"
                                pTooltip="Task Manager"
                                icon="pi pi-check-square">
                                <span class="sr-only">Task Manager</span>
                            </p-button>
                        }
                    </div>
                }
            </div>

            <!-- Bottom -->
            <div class="flex flex-col items-center justify-start gap-2 w-full">
                @if (panelOpen) {
                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        (click)="onClickTestAutioAndVideo()"
                        [routerLink]="'/session/' + currentUser.userId"
                        severity="secondary"
                        [outlined]="true"
                        class="w-full"
                        styleClass="w-full">
                        <div class="w-full flex items-center justify-start">
                            <div>
                                <i class="pi pi-video" style="font-size: 14px"></i>
                                <span class="ml-1 font-semibold">Test audio and video</span>
                            </div>
                        </div>
                    </p-button>
                } @else {
                    <p-button
                        [buttonProps]="{ autofocus: false }"
                        [routerLink]="'/session/' + currentUser.userId"
                        (click)="onClickTestAutioAndVideo()"
                        size="small"
                        severity="secondary"
                        [outlined]="true"
                        pTooltip="Test Audio and Video"
                        styleClass="aspect-square"
                        icon="pi pi-video">
                        <span class="sr-only">Test audio and video</span>
                    </p-button>
                }
            </div>
        </div>
    </div>
</div>
